export const SET_DEFAULT_SEARCH = 'esri-search-set';
export const STYLE_SEARCH = 'esri-search-update-style';
export const RESTRICT_SEARCH = 'esri-search-restrict';
export const SEARCH_CHANGED = 'esri-search-changed';
export const SEARCH_FLYTO = 'esri-search-flyto';
